import Box from "@mui/material/Box";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./RankingPreview.css";

const RankingPreview = ({ question }) => {
  const { config = {}, options = [] } = question;
  const { color, iconInfo = [] } = config;

  return (
    <>
      <Box className="ranking-preview-options">
        {options &&
          options.map((option) => (
            <Box key={option?.id} className="ranking-preview-option">
              <Box>
                <FontAwesomeIcon
                  icon={iconInfo}
                  className="ranking-preview-option__icon"
                  style={{ color: color || "#0000003B" }}
                />
              </Box>
              <Box className="ranking-preview-option__text">
                {option?.option || ""}
              </Box>
            </Box>
          ))}
      </Box>
    </>
  );
};

export default RankingPreview;
